export const eventSeriesStates = ['active', 'passive', 'completed', 'discontinued'] as const;
export type EventSeriesStatus = (typeof eventSeriesStates)[number];

export const eventStates = [
    'active-idea',
    'active-option',
    'active-fix',
    'passive',
    'discontinued',
    'completed',
    'canceled',
] as const;
export type EventStatus = (typeof eventStates)[number];

export const ACTIVE_EVENT_STATES = ['active-idea', 'active-option', 'active-fix'];
export const ACTIVE_EVENT_VARIANT_STATES = ['active-1', 'active-2'];

export const eventVariantStates = ['active-1', 'active-2', 'passive', 'discontinued'] as const;
export type EventVariantStatus = (typeof eventVariantStates)[number];
